import { render } from "./WideCampaignCard.vue?vue&type=template&id=6f9e2f54&scoped=true"
import script from "./WideCampaignCard.vue?vue&type=script&lang=js"
export * from "./WideCampaignCard.vue?vue&type=script&lang=js"

import "./WideCampaignCard.vue?vue&type=style&index=0&id=6f9e2f54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9e2f54"]])

export default __exports__